export const COLOR = 'Color';
//# sourceMappingURL=color.js.map